<template>
  <div class="login-container">
    <div class="content-container" style="padding-top:80px;">
      <div style="height: 40px;margin-bottom:24px;">
        <img src="@/assets/user_images/jdLogo.png" alt="" height="40" style="height: 40px;">
        <div style="float:right;font-size: 14px;color:rgba(0,0,0,0.65);line-height: 40px;">
          <span v-if="showLogo">
            已有账号？<span style="color:#05A7EA;cursor: pointer;" @click="goLogin">立即登录</span>
            <span style="border-right:1px solid rgba(0,0,0,0.1);margin:0 24px;"></span>
          </span>

          <span style="color:#05A7EA;cursor: pointer;" @click="backWeb">返回主页</span>
        </div>
      </div>
      <div class="loginContent">
        <div class="theme">注&nbsp;&nbsp;&nbsp;册</div>
        <div class="register">
          <ul class="step-box">
            <li class="step-item" style="width:253px">
              <div class="setp-num" :style="step1.step">
              </div>
              <div class="title" :style="step1.stepTitle">注册</div>
              <div class="setp-line" :style="step1.stepLine"></div>
            </li>
            <li class="step-item" style="width:323px">
              <div class="setp-num" :style="step2.step">
              </div>
              <div class="title" :style="step2.stepTitle">填写基本信息</div>
              <div class="setp-line" :style="step2.stepLine"> </div>
            </li>
            <li class="step-item last-item">
              <div class="setp-num" :style="step3.step">
              </div>
              <div class="title" :style="step3.stepTitle">提交审核</div>
            </li>
          </ul>
        </div>
        <div class="registerForm" v-if='currentStep == 1'>
          <el-form :model="formData" ref="formData" class="demo-ruleForm" :rules="rules">
            <el-form-item label="" prop="email">
              <el-input v-model="formData.email" placeholder="请输入邮箱">
              </el-input>

            </el-form-item>
            <el-form-item label="" prop='code'>
              <el-input v-model="formData.code" placeholder="请输入验证码">
              </el-input>
              <el-button
                style="position: absolute;right: 1px;color:#05A7EA;font-size:14px;top:1px;border:none;height:40px!important;background: transparent;"
                @click="getVerificationCode" :disabled="noClick" v-if="isSend">获取验证码</el-button>
              <el-button v-else
                style="position: absolute;right: 1px;color:#05A7EA;font-size:14px;top:1px;border:none;height:40px!important;background: transparent;"
                @click="getVerificationCode" :disabled="noSend">重新发送{{ time }}s</el-button>

            </el-form-item>
            <el-form-item label="" prop="pwd">
              <el-input type="password" v-model="formData.pwd" placeholder="8位密码，包含字母和数字">
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="confirmPassword">
              <el-input type="password" v-model="formData.confirmPassword" placeholder="请再次输入密码">
              </el-input>
            </el-form-item>
            <el-form-item label="">
              <el-checkbox v-model="checked" style="font-size: 14px">我已阅读并接受</el-checkbox><span
                style="color:#05A7EA;font-size:14px;cursor: pointer;" @click="userAgree">《用户协议》</span>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" style="width:100%;height:40px!important" @click="login('formData')"
                :disabled="isClick">提交
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="registerForm" v-if="currentStep == 2 && status == 2">
          <el-form :model="basicInfo" ref="basicInfo" class="demo-ruleForm" :rules="rules" @submit.native.prevent>
            <el-form-item label="" prop="linkman">
              <el-input v-model="basicInfo.linkman" autocomplete="off" placeholder="请输入联系人">
              </el-input>

            </el-form-item>

            <el-form-item label="" prop="telephone">
              <el-input v-model="basicInfo.telephone" autocomplete="off" placeholder="请输入联系电话">
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="qq">
              <el-input v-model="basicInfo.qq" autocomplete="off" placeholder="请输入QQ号码">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="width:100%;height:40px!important" @click="info('basicInfo')">提交
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="registerForm" v-if="currentStep == 3 && status == 3" style="text-align: center;width:434px">
          <div v-if="status == 3">
            <img src="@/assets/user_images/审核中.png" alt="">
            <div style="margin-top:40px;margin-bottom:16px;font-size:18px;color:rgba(0,0,0,0.85);font-weight:700">
              信息审核中
            </div>
            <div style="font-size:14px;color:rgba(0,0,0,0.65);">
              审核结果将在三个工作日内通过新邮件和短信发送给您，请耐心等待！
            </div>
          </div>
        </div>
        <div class="registerForm" v-if="currentStep == 3 && status == 4" style="text-align: center;width:434px">
          <div>
            <img src="@/assets/user_images/nopass.png" alt="">
            <div style="margin-top:40px;margin-bottom:16px;font-size:18px;color:rgba(0,0,0,0.85);font-weight:700">
              审核未通过
            </div>
            <div style="font-size:14px;color:rgba(0,0,0,0.65);">
              拒绝原因：{{ remark }}
            </div>
            <div style="font-size:14px;color:rgba(0,0,0,0.65);margin-top:6px">
              您可再次填写信息 <span style="color:#05A7EA;cursor: pointer;" @click="reCommit">重新提交</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import md5 from 'js-md5'
import { validUsername } from '@/utils/validate'
import current1 from '@/assets/current-step-1.png'
import current2 from '@/assets/current-step-2.png'
import current3 from '@/assets/current-step-3.png'
import default2 from '@/assets/default-step-2.png'
import default3 from '@/assets/default-step-3.png'
import successStep from '@/assets/success-step.png'
import { validatePassword, validateTelphone, validateQq } from "@/api/validate"
import { getCode, checkEmail, register, updateInfo, basicInfo } from "@/api/register"
import {
  setStroage,
  getStroage
} from '@/utils/auth' // get token from
import Setting from '@/settings.js'
var { webDomain, locatDomain } = Setting
export default {
  name: 'Login',
  computed: {
    step1: function () {
      const _this = this
      var _result = {}
      _result.step = current1
      _result.title = "rgba(000,000,000,0.85)"
      _result.line = '#05A7EA'
      _result.fontWeight = 600
      return {
        step: {
          backgroundImage: 'url(' + _result.step + ')',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100% 100%'
        },
        stepTitle: {
          color: _result.title,
          fontWeight: _result.fontWeight
        },
        stepLine: {
          borderColor: _result.line
        }
      }
    },
    step2: function () {
      const _this = this
      var _result = {}
      if (_this.currentStep == 2 || _this.currentStep == 3) {
        _result.step = current2
        _result.title = "rgba(000,000,000,0.85)"
        _result.line = '#05A7EA'
        _result.fontWeight = 600
      } else {
        _result.step = default2
        _result.title = "rgba(000,000,000,0.45)"
        _result.line = '#e9e9e9e9'
        _result.fontWeight = 100
      }
      return {
        step: {
          backgroundImage: 'url(' + _result.step + ')',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100% 100%'
        },
        stepTitle: {
          color: _result.title,
          fontWeight: _result.fontWeight
        },
        stepLine: {
          borderColor: _result.line
        }
      }
    },
    step3: function () {
      const _this = this
      var _result = {}
      if (_this.currentStep == 3) {
        _result.step = current3
        _result.title = "rgba(000,000,000,0.85)"
        _result.line = '#e9e9e9e9'
        _result.fontWeight = 600
      } else {
        _result.step = default3
        _result.title = "rgba(000,000,000,0.45)"
        _result.line = '#e9e9e9e9'
        _result.fontWeight = 100
      }

      return {
        step: {
          backgroundImage: 'url(' + _result.step + ')',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100% 100%'
        },
        stepTitle: {
          color: _result.title,
          fontWeight: _result.fontWeight
        },
        stepLine: {
          borderColor: _result.line
        }
      }
    }
  },
  watch: {
    checked(val, oldVal) {//普通的watch监听
      if (val && this.formData.email && this.formData.pwd && this.formData.code && this.formData.confirmPassword) {
        this.isClick = false
      } else {
        this.isClick = true
      }
    },
    formData: {
      handler(newValue, oldValue) {
        if (this.checked && newValue.email && newValue.pwd && newValue.code && newValue.confirmPassword) {
          this.isClick = false
        } else {
          this.isClick = true
        }

      },
      deep: true
    }
  },
  mounted() {
    var step = this.$route.query.step
    var method = this.$route.query.method
    var url = window.location.href.split("=")[1]
    if (step || url) {
      var s = step ? parseInt(step) : parseInt(url)
      this.changeStep(s)
    } else {
      this.currentStep = 1
    }
    if (this.currentStep == 1) {
      this.showLogo = true
    } else {
      this.showLogo = false
    }
    if (method == 1) {

    } else {
      this.getBasic()
    }

  },
  data() {
    return {
      current1: current1,
      currentStep: 1,
      checked: false,
      noClick: true,
      formData: {
        code: null,
        email: null,
        pwd: null,
        confirmPassword: null
      },
      remark: null,
      isClick: true,
      basicInfo: {
        linkman: null,
        telephone: null,
        qq: null
      },
      status: null,
      isShow: false,
      isSend: true,
      time: 60,
      noSend: false,
      showLogo: true,
      rules: {
        email: [{
          required: true,
          validator: this.validateStrEmail,
          trigger: 'blur'
        }],
        pwd: [{
          required: true,
          validator: validatePassword,
          trigger: 'blur'
        }],
        confirmPassword: [{
          required: true,
          validator: this.validateConfirmPwd,
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }],
        linkman: [{ required: true, message: '请输入联系人名称', trigger: 'blur' },
        { max: 10, message: '长度不能超过10', trigger: 'blur' }],
        telephone: [{ required: true, validator: validateTelphone, trigger: 'blur' }],
        qq: [{ required: true, validator: validateQq, trigger: 'blur' }]

      },
    }
  },
  methods: {
    // 邮箱校验
    validateStrEmail(rule, value, callback) {
      var re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
      if (value == '' || value == null || value == undefined) {
        callback(new Error('邮箱不能为空'))
      } else if (value.length < 6 || value.length > 32) {
        callback(new Error('请输入6-32位的邮箱'))
      } else if (!re.exec(value)) {
        callback(new Error('邮箱格式不正确'))
      } else {
        // 唯一性校验
        checkEmail({
          email: this.formData.email
        }).then(res => {
          if (res && res.code == 0) {
            if (res.data.result) {
              this.noClick = true
              callback(new Error('该邮箱已经注册'))
            } else {
              this.noClick = false
              callback()
            }
          } else {
            this.$message.error(res.msg)
          }
        })

      }
    },
    // 再次确认密码校验
    validateConfirmPwd(rule, value, callback) {
      if (value == '' || value == null || value == undefined) {
        callback(new Error('请再次确认密码'))
      } else if (value != this.formData.pwd) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    },
    goLogin() {
      this.$router.push("/login")
    },
    getBasic() {
      basicInfo().then(res => {
        if (res && res.code == 0) {
          this.status = res.data.userInfo.reviewStatus
          this.basicInfo.linkman = res.data.userInfo.name
          this.basicInfo.telephone = res.data.userInfo.telephone
          this.basicInfo.qq = res.data.userInfo.qq
          this.remark = res.data.userInfo.reviewRemark
          if (this.status == 1) {
            this.$router.push("/home")
          } else if (this.status == 4 || this.status == 3) {
            this.currentStep = 3
          }
        }
      })
    },
    backWeb() {
      this.$router.push("/dosh")
    },
    userAgree() {

      window.open(locatDomain + '/#/agreement')
    },
    //更改step状态
    changeStep(_step) {
      const _this = this
      this.currentStep = _step
    },
    reCommit() {
      this.currentStep = 2
      this.status = 2
    },
    showTime() {
      this.isSend = false
      this.noSend = true
      this.time = 60
      const remainingTime = setInterval(() => {
        if (this.time > 0) {
          this.time--
        } else {
          clearInterval(remainingTime);
          this.isSend = true
        }
      }, 1000)

    },
    // 获取验证码
    getVerificationCode() {
      this.showTime()
      getCode({
        email: this.formData.email,
        isFlag: '0'
      }).then(res => {
        if (res && res.code == 0) {

        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 登录
    login(formName) {
      const _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let password = md5(this.formData.pwd)
          register({
            email: _this.formData.email,
            pwd: password,
            code: _this.formData.code,
            isFlag: '0'
          }).then(res => {
            if (res && res.code == 0) {
              this.status = res.data.userStatus
              setStroage('userStatus', res.data.reviewStatus)
              setStroage('token', res.data.token)
              this.$router.push({ path: '/register', query: { step: 2 } })
              _this.changeStep(2)
            } else {
              _this.$message.error(res.msg)
            }
          })
        } else {
          console.log(111111)
        }
      })
    },
    info(formName) {
      const _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateInfo(this.basicInfo).then(res => {
            if (res && res.code == 0) {
              this.status = res.data.userStatus
              this.changeStep(3)
            } else {
              this.$message.error(res.msg)
            }
          })

        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: rgba(0, 0, 0, 0.65);
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;
$success: #05A7EA;
$stepHeight: 32px;

.step-box {
  height: $stepHeight;
  // width: 60%;
  width: 728px;
  margin: 0px auto;
  overflow: hidden;

  // background: pink;
  .step-item {
    float: left;
    width: 295px;
    height: $stepHeight;

    div {
      display: inline-block;
      float: left;
    }

    .setp-line {
      border-bottom: 1px solid #e9e9e9;
      height: 16px;
      width: 150px;

    }

    .title {
      padding: 0px 8px;
      color: rgba($color: #000000, $alpha: 0.45);
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      line-height: $stepHeight;
    }

    .setp-num {
      height: $stepHeight;
      width: $stepHeight;
      text-align: center;
      // background: rgba($color: #000000, $alpha: 0.15);
      line-height: $stepHeight;
      font-size: 23px;
      border-radius: 100%;
      position: relative;
      color: rgb(255, 255, 255);
      // .setp-line-in {
      //   position: relative;
      //   background: #ffffff;
      //   color: rgba($color: #000000, $alpha: 0.15);
      //   height: 57px;
      //   width: 58px;
      //   left: 1px;
      //   top: 2px;
      //   border-radius: 50%;
      // }
    }

    // .setp-num-active {
    //   background: $success;
    // }
  }

  .last-item {
    width: 136px;
  }
}

.login-container {
  min-height: 100%;
  width: 100%;
  overflow: hidden;
  background: #F4F4F4;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 160px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}

.loginContent {

  background: #FFFFFF;
  padding-bottom: 80px;
  border-radius: 0px 0px 10px 10px;
}

.theme {
  height: 60px;
  background: #1C2B36;
  text-align: center;
  color: #05A7EA;
  font-size: 22px;
  border-radius: 10px 10px 0px 0px;
  line-height: 60px;
}

.register {
  background-color: #fff;
  border-radius: 0px 0px 10px 10px;
  padding: 60px 147px 80px 147px;
}

ul,
li {
  list-style: none;
  margin: 0px;
  padding: 0px;
}

.registerForm {
  width: 362px;
  margin: 0 auto;
  height: 400px;
}

/deep/.el-input__inner {
  height: 40px;
  line-height: 40px;
}
</style>
